import { render, staticRenderFns, recyclableRender, components } from "./luggage-storage.vue?vue&type=template&id=c13e4c60&scoped=true&"
var renderjs
import script from "./luggage-storage.vue?vue&type=script&lang=js&"
export * from "./luggage-storage.vue?vue&type=script&lang=js&"
import style0 from "./luggage-storage.vue?vue&type=style&index=0&id=c13e4c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13e4c60",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/luggage-storage/luggage-storage.vue"
export default component.exports